import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { passwordRegexValidator } from '@src/app/shared/validators/password.validator';
import { confirmPasswordValidator } from '@src/app/shared/validators/confirmPassword.validator';
import { ToasterService } from '@src/app/shared/components/toaster/toaster.service';
import { forkJoin, firstValueFrom } from 'rxjs';
import { ConfirmNewPasswordRequest, UsersService } from '@src/app/shared/backend/clients';

@Component({
	selector: 'app-new-password',
  standalone: false,
	templateUrl: './new-password.component.html',
	styleUrls: ['./new-password.component.scss'],
	host: {
		class: 'app-new-password'
	}
})
export class NewPasswordComponent implements OnInit {
  confirmationCode: any;
  formSuccess: boolean = false;
  errorTitle: string = '';
  errorMessage: string = '';

  public newPasswordFormGroup = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required, passwordRegexValidator()]],
    confirmPassword: ['', [Validators.required, confirmPasswordValidator('password')]]
  });

  constructor(
    private usersService: UsersService,
    private fb: FormBuilder,
    public translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['code']) {
        this.confirmationCode = params['code'];
      } else {
        forkJoin({
          errTitle: this.translate.get('NEW_PASSWORD.ERROR_RESET_PASSWORD_TITLE'),
          errMessage: this.translate.get('NEW_PASSWORD.ERROR_RESET_PASSWORD_MESSAGE')
        }).subscribe(translations => {
          this.errorTitle = translations.errTitle;
          this.errorMessage = translations.errMessage;
          this.toasterService.show('error', this.errorTitle, this.errorMessage, 6000);
        });
      }
    });
  }

  async newPassword() {
    if (this.newPasswordFormGroup.valid) {

      const username = this.newPasswordFormGroup.get('username')?.value;
      const newPassword = this.newPasswordFormGroup.get('password')?.value;

      if (username !== null && username !== undefined && newPassword !== null && newPassword !== undefined) {
        const payload: ConfirmNewPasswordRequest = {
          username,
          newPassword,
          confirmationCode: this.confirmationCode
        };
        await firstValueFrom(this.usersService.apiUsersConfirmNewPasswordPut(payload));
        this.formSuccess = true;
      }
    }
  }

  submitOnPressEnter(event: any) {
    if (event.keyCode === 13) {
      this.newPassword();
    }
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }
}
